/**
 * Review-only structured source accompanies DEV landing rows. Production
 * cannot consume this payload, even if an unrelated app build contains this
 * helper. Import/publication tooling must preserve its explicit hold.
 */
export const SOURCE_MARKER = "remaining-driveshare-development-source";
export const DEVELOPMENT_SOURCE_PATHS = new Set([
  "/BMW", "/FordMustangs", "/ChevroletCorvettes", "/ChevroletCamaros", "/Pontiac",
  "/Mopars", "/Plymouth", "/TrucksandSUVs", "/featuredUSlistings", "/ListaFord",
  "/FordorChevrolet", "/RentaClassicorModernDodge", "/fallcolorcruises", "/summerfun",
  "/SummerOccasions", "/drivetobedifferent", "/travelguides", "/weddinglist",
  "/why-rent", "/classic-car-rental-london", "/why-list",
]);
export function developmentSourcePreviewPath(pathname, env) {
  return env.NODE_ENV === "development" && env.DRIVESHARE_LEGACY_SEO_ENABLED === "true" &&
    DEVELOPMENT_SOURCE_PATHS.has(pathname);
}
export function developmentLandingSource(body, development = false) {
  if (!development || typeof body !== "string") return null;
  const match = body.match(/<script type="application\/json" id="remaining-driveshare-development-source">([\s\S]*?)<\/script>/);
  if (!match) return null;
  let value;
  try { value = JSON.parse(match[1]); } catch { throw new Error("Invalid development source payload"); }
  if (value?.developmentOnly !== true || value?.productionPublicationApproved !== false ||
      !value.source?.heading || !value.source?.hero?.src || !value.source?.introBlocks?.length ||
      JSON.stringify(value.source).includes("staged:")) {
    throw new Error("Incomplete or unheld development source payload");
  }
  return value.source;
}
export function developmentSourceBody(draft) {
  if (draft.developmentOnly !== true || draft.productionPublicationApproved !== false) {
    throw new Error("Supplemental source must retain its development-only publication hold");
  }
  const paragraphs = (draft.source.sections || []).filter(section => section.kind === "editorial")
    .flatMap(section => section.blocks || []).map(block => {
      if (block.type === "html") return block.html;
      const text = String(block.text || "").replace(/[&<>]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" })[c]);
      return `<${block.type === "h2" ? "h2" : "p"}>${text}</${block.type === "h2" ? "h2" : "p"}>`;
    }).join("\n");
  return `${paragraphs}\n<script type="application/json" id="${SOURCE_MARKER}">${
    JSON.stringify({ developmentOnly: true, productionPublicationApproved: false, source: draft.source }).replace(/</g, "\\u003c")
  }</script>`;
}
